<template>
    <router-view />
</template>

<script>
export default {
    name: "light-ray",
};
</script>

<style lang="scss" scoped></style>
